export default class LoginRequest {
	username: string | null = null;
	password: string | null = null;
	hash: string | null = null;

	constructor(username: string | null, password: string | null, hash: string | null) {
		this.username = username;
		this.password = password;
		this.hash = hash;
	}

	public static InstanceFromHash(hash: string) {
		return new LoginRequest(null, null, hash);
	}

	public static InstanceFromLogin(username: string, password: string) {
		return new LoginRequest(username, password, null);
	}
}
